<style scoped>
.tables /deep/ .el-table__body-wrapper .el-table__body tbody tr {
  padding-top: 18px;
  padding-bottom: 0;
}

.sub-form-item /deep/ .el-form-item__content {
  margin-left: 1px !important;
}
</style>
<template>
  <div style="display: inline;">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"></yi_curd_table>
    <el-form ref="form" size="mini" :model="form" label-width="235px">
      <el-form-item :label="$t('wuliaobianma/mingcheng')" class="noborder">
        <yi_cross_select disabled :max="1" :selectTitle="'code,name'" :component="'web_base_matter_list'" :ids.sync="$attrs.outbound.materialId"> </yi_cross_select>
      </el-form-item>
      <el-form-item :label="$t('sehao')" class="noborder" v-if="colorNoEnable">
        <el-input disabled :value="$t(store.state.dictJsonAll['CUSTOMER_MATERIAL_COLOR_NO'][$attrs.outbound.colorNo])"></el-input>
      </el-form-item>
      <el-form-item :label="$t('weichushuliang')" class="noborder">
        <el-input disabled v-model="$attrs.outbound.dueQuantity"></el-input>
      </el-form-item>
      <el-form-item :label="$t('danwei')" class="noborder">
        <el-input disabled v-model="store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][$attrs.outbound.unit]"></el-input>
      </el-form-item>
      <el-form-item :label="$t('bencishichu')" class="noborder">
        <el-input-number disabled :precision="5" size="mini" v-model="accumulate" :controls="false" class="input3"> </el-input-number>
      </el-form-item>
      <el-form-item :label="$t('chukushuliang')" class="noborder">
        <el-input disabled v-model="$attrs.outbound.quantity"></el-input>
      </el-form-item>
      <!--选择库存-->
      <div style="margin-bottom: 8px">
        <yi_cross_select :selectTitle="'material.name'" ref="material" buttonType="primary" :inventory="$attrs.outbound" :component="'web_wms_delivery_issue_check_select_inventory'" multiple :isInput="true" :isButton="true" :buttonTitle="'xuanzekucun'" :ids.sync="materialList" @getItems="getItems" :colorNoEnable="colorNoEnable"> </yi_cross_select>
      </div>
      <el-table class="tables" :data="form.materialInventoryList" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', 'font-size': '14px', height: '48px', padding: '0px' }" :show-overflow-tooltip="true" size="mini" border stripe max-height="600">
        <el-table-column prop="newTransactionQuantity" :label="$t('bencishichu')" width="176">
          <template slot-scope="scope">
            <el-input-number @change="handleChange" :precision="5" :step="0.00001" :min="0.00001" size="mini" v-model="scope.row.newTransactionQuantity" :controls="false" class="input"> </el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="materialCode" :label="$t('wuliaobianma')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.materialCode'">
              <span>{{ scope.row.materialCode }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" :label="$t('wuliaomingcheng')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.materialName'">
              <span>{{ scope.row.materialName }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="colorNo" :label="$t('sehao')" width="150" :show-overflow-tooltip="true" v-if="colorNoEnable">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.colorNo'">
              <span>{{ $t(store.state.dictJsonAll['CUSTOMER_MATERIAL_COLOR_NO'][scope.row.colorNo]) }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="materialValue" :label="$t('chanpinfenlei')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.materialValue'">
              <span> {{ $t(store.state.dictJsonAll['GYLXCPFL'][scope.row.materialValue]) }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseCode" :label="$t('cangkubianma')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.warehouseCode'">
              <span>{{ scope.row.warehouseCode }}</span>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column prop="warehouseName" :label="$t('cangkumingcheng')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.warehouseName'">
              <span>{{ scope.row.warehouseName }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseAddress" :label="$t('cangkudizhi')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.warehouseAddress'">
              <span>{{ scope.row.warehouseAddress }}</span>
            </el-form-item>
          </template>
        </el-table-column>

        <el-table-column prop="warehouseAreaCode" :label="$t('kuqubianma')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.warehouseAreaCode'">
              <span>{{ scope.row.warehouseAreaCode }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseAreaName" :label="$t('kuqumingcheng')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.warehouseAreaName'">
              <span>{{ scope.row.warehouseAreaName }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseLocationCode" :label="$t('kuweibianma')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.warehouseLocationCode'">
              <span>{{ scope.row.warehouseLocationCode }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseLocationName" :label="$t('kuweibianma')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.warehouseLocationName'">
              <span>{{ scope.row.warehouseLocationName }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="unit" :label="$t('danwei')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.unit'">
              <span> {{ $t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.unit]) }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="total" :label="$t('zongshu')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.total'">
              <span>{{ scope.row.total }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="available" :label="$t('keyongshu')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.available'">
              <span>{{ scope.row.available }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="allocated" :label="$t('yifenpeishu')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.allocated'">
              <span>{{ scope.row.allocated }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" :label="$t('gongyingshangmingcheng')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.supplierName'">
              <span>{{ scope.row.supplierName ? scope.row.supplierName : '' }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="materialBatchNo" :label="$t('wuliaopicihao')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.materialBatchNo'">
              <span>{{ scope.row.materialBatchNo }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column prop="productionBatchNo" :label="$t('shengchanpicihao')" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-form-item class="sub-form-item" :prop="'materialInventoryList.' + scope.$index + '.productionBatchNo'">
              <span>{{ scope.row.productionBatchNo }}</span>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column :label="$t('caozuo')" class="caozuo" fixed="right">
          <template slot-scope="scope">
            <span style="color:#F56C6C;font-size: 14px;font-family: Microsoft YaHei UI;" @click="deleteRow(scope.$index, scope.row)">{{ $t('shanchu') }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_wms_delivery_without_order_check_outbound_order',
  props: {
    // 生产配置-产品色号管理
    colorNoEnable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultMaterialInventory: null,
      key: 0,
      materialList: [],
      substantiationNum: null,
      allList: [],
      form: {
        // id:'',
        ...this.$attrs.outbound,
        materialInventoryList: []
      }
    };
  },
  computed: {
    accumulate() {
      let total = 0;
      if (this.allList.length > 0) {
        for (let i = 0; i < this.allList.length; i++) {
          if (this.allList[i].newTransactionQuantity !== null && this.allList[i].newTransactionQuantity !== undefined) {
            total += this.allList[i].newTransactionQuantity;
          }
        }
      }
      return total;
    }
  },
  created() {
    // 在组件创建时调用获取默认库存的函数
    this.getItemDefaultWarehouseInventory();
  },
  watch: {
    'form.materialInventoryList': {
      handler(n, o) {
        if (n) {
          this.allList = n;
        }
      },
      immediate: true,

      deep: true
    }
  },
  methods: {
    addRedStar(h, { column }) {
      // 给表头加必选标识
      return [
        h(
          'span',
          {
            style: 'color: red'
          },
          '*'
        ),
        h('span', ' ' + column.label)
      ];
    },
    //本次实出值变化
    handleChange(value) {},
    // 删除行
    deleteRow(index, row) {
      this.form.materialInventoryList.splice(index, 1);
    },
    // 获取选中数据
    getItems(checks) {
      // this.form.id = this.$attrs.outbound.id
      console.log('checks', checks);
      for (let i = 0; i < checks.length; i++) {
        const res = this.form.materialInventoryList.filter(item => {
          return item.id === checks[i]['id'];
        });
        if (res.length > 0) {
          continue;
        }

        const item = {
          id: checks[i]['id'],
          materialCode: checks[i]['material'] == null ? '' : checks[i]['material'].code,
          materialName: checks[i]['material'] == null ? '' : checks[i]['material'].name,
          materialValue: checks[i]['material'] == null ? '' : checks[i]['material'].value,
          warehouseCode: checks[i]['warehouse'] == null ? '' : checks[i]['warehouse'].code,
          // warehouseName: checks[i]['warehouse'] == null ? '' : checks[i]['warehouse'].code,
          warehouseName: checks[i]['warehouse'] == null ? '' : checks[i]['warehouse'].name,
          warehouseAddress: checks[i]['warehouse'] == null ? '' : checks[i]['warehouse'].address,
          warehouseAreaCode: checks[i]['warehouseArea'] == null ? '' : checks[i]['warehouseArea'].code,
          warehouseAreaName: checks[i]['warehouseArea'] == null ? '' : checks[i]['warehouseArea'].name,
          warehouseLocationCode: checks[i]['warehouseLocation'] == null ? '' : checks[i]['warehouseLocation'].code,
          warehouseLocationName: checks[i]['warehouseLocation'] == null ? '' : checks[i]['warehouseLocation'].name,
          unit: checks[i]['unit'],
          total: checks[i]['total'],
          available: checks[i]['available'],
          allocated: checks[i]['allocated'],
          supplierName: checks[i]['supplier'] == null ? '' : checks[i]['supplier'].name,
          materialBatchNo: checks[i]['materialBatchNo'],
          productionBatchNo: checks[i]['productionBatchNo'],
          colorNo: checks[i]['colorNo']
        };
        this.form.materialInventoryList.push(item);
      }
      ++this.key;
      this.materialList = [];
    },
    //查询物料默认库存数据
    async getItemDefaultWarehouseInventory() {
      let response = await this.http.get('/web/material/inventory/getItemDefaultWarehouseInventory', {
        params: {
          materialId: this.$attrs.outbound.materialId,
          colorNo: this.$attrs.outbound.colorNo
        }
      });
      this.defaultMaterialInventory = response.data;
      if (this.defaultMaterialInventory) {
        if (this.defaultMaterialInventory.material) {
          this.defaultMaterialInventory.materialName = this.defaultMaterialInventory.material.name;
          this.defaultMaterialInventory.materialCode = this.defaultMaterialInventory.material.code;
          this.defaultMaterialInventory.materialValue = this.defaultMaterialInventory.material.value;
        }
        if (this.defaultMaterialInventory.warehouse) {
          this.defaultMaterialInventory.warehouseCode = this.defaultMaterialInventory.warehouse.code;
          this.defaultMaterialInventory.warehouseName = this.defaultMaterialInventory.warehouse.name;
        }
        if (this.defaultMaterialInventory.warehouseArea) {
          this.defaultMaterialInventory.warehouseAreaCode = this.defaultMaterialInventory.warehouseArea.code;
          this.defaultMaterialInventory.warehouseAreaName = this.defaultMaterialInventory.warehouseArea.name;
        }
        if (this.defaultMaterialInventory.warehouseLocation) {
          this.defaultMaterialInventory.warehouseLocationCode = this.defaultMaterialInventory.warehouseLocation.code;
          this.defaultMaterialInventory.warehouseLocationName = this.defaultMaterialInventory.warehouseLocation.name;
        }
        if (this.defaultMaterialInventory.supplier) {
          this.defaultMaterialInventory.supplierName = this.defaultMaterialInventory.supplier.name;
        }
        const dueQuantity = this.$attrs.outbound.dueQuantity;
        this.defaultMaterialInventory.newTransactionQuantity = dueQuantity >= this.defaultMaterialInventory.total ? this.defaultMaterialInventory.total : (this.defaultMaterialInventory.newTransactionQuantity = dueQuantity);
        this.form.materialInventoryList.push(this.defaultMaterialInventory);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dialog /deep/ .el-dialog__body {
  overflow: auto;
}

.input /deep/ .el-input__inner {
  width: 150px;
}

.input1 /deep/ .el-input__inner {
  width: 220px;
}

.input3 /deep/ .el-input__inner {
  width: 200px;
  text-align: left;
}
</style>
